App.SettingsBusinessRoleEditController = Em.Controller.extend
  session: Em.inject.service()

  businessRoleBinding: 'model'

  needs: [ 'settingsBusinessRole' ]

  isSaving: false
  env:   Em.inject.service('environment')
  session: Em.inject.service()

  availableStatuses: ['draft', 'pending', 'confirm', 'preparing', 'prepared', 'delivery', 'undo', 'complete']

  selectedStatuses: (->
    currentStatuses = @get('businessRole.permitted_statuses') || []
    currentStatuses.map (status) =>
      {
        id: status,
        text: @get('env').translate("order.status.#{status}")
      }
  ).property('businessRole.permitted_statuses')

  orderStatuses: []
  initSelectValues: (->
    @set('orderStatuses', @get('availableStatuses').map (status) =>
      {
        id: status,
        text: @get('env').translate("order.status.#{status}")
      })
  ).on('init')

  actions:
    ###
    # Сохранить бизнес роль
    ###
    saveBusinessRole: ->
      businessRole = @get('businessRole')
      @set('isSaving', true)

      wasNew = businessRole.get('isNew')

      statuses = @get('selectedStatuses').map (status) -> status.id
      businessRole.set('permitted_statuses', statuses)

      org = @get('session.currentOrganization')
      businessRole.set('organization', org)

      businessRole.save()
      .then (businessRole) =>
        @transitionToRoute('settings.business-role.show', businessRole.get('id'))
      .catch =>
        false
      .finally =>
        @set('isSaving', false)
      false

    ###
    # Удалить бизнес роль
    ###
    deleteBusinessRole: ->
      return unless confirm(Em.I18n.t 'settings.business_role.delete')

      businessRole = @get('businessRole')

      businessRole.destroyRecord()
      .finally =>
        @send('goBackToBusinessRoleList')
      false

    ###
    # Отменить изменения
    ###
    cancel: ->
      return unless confirm(Em.I18n.t 'settings.business_role.cancel')

      businessRole = @get('businessRole')
      businessRole.rollback()

      @send('goBackToBusinessRoleList')
      false

    ###
    # Назад
    ###
    goBackToBusinessRoleList: ->
      @transitionToRoute('settings.business-role')
      false
